import { get, post } from '@/http/axios';

/**
 * 获取终端型号备案列表
 */
export function getTerminalList(params) {
  return get({
    url: '/transfer/nonRoadCemissionsDevicemodel/page',
    params,
    hasLoading: true
  });
}

/**
 * 新增或编辑终端型号
 * @param {*} params
 * @returns
 */
export function updateTerminalModel(data) {
  if (data.id) {
    return post({
      url: '/transfer/nonRoadCemissionsDevicemodel/update',
      data,
      hasLoading: true
    });
  }
  return post({
    url: '/transfer/nonRoadCemissionsDevicemodel/insert',
    data,
    hasLoading: true
  });
}

/**
 * 根据ID获取详情
 */
export function getDetailById(id) {
  return get({
    url: '/transfer/nonRoadCemissionsDevicemodel/id',
    params: {
      id
    }
  });
}

/**
 * 终端型号备案
 */
export function recordTerminalModel(id) {
  return post({
    url: '/transfer/nonRoadCemissionsDevicemodel/recordToPlatform',
    data: {
      id
    }
  });
}

/**
 * 备案结果查询
 */
export function getRecordResult(id) {
  return get({
    url: '/transfer/nonRoadCemissionsDevicemodel/queryFromPlatform',
    params: {
      id
    },
    hasLoading: true
  });
}

/**
 * 终端型号备案通过id删除
 */
 export function deletTerminalModelById(id) {
  return post({
    url: '/transfer/nonRoadCemissionsDevicemodel/delete',
    data: {
      id
    }
  });
}